const data = [
  {
    id: "dashboard",
    icon: "iconsminds-monitor-analytics",
    label: "menu.dashboard",
    to: "/app/dashboard",
    role: [
      "admin",
      "superAdmin",
      "customerService"
    ]
  },
  {
    id: "providers",
    icon: "iconsminds-shop",
    label: "menu.service_providers",
    to: "/app/providers",
    role: [
      "superAdmin",
      "admin",
      "customerService",
      'finance'

    ]
  },
  {
    id: "workers",
    icon: "iconsminds-engineering",
    label: "menu.workers",
    to: "/app/workers",
    role: [
      "superAdmin",
      "admin",
      "customerService"

    ]
  },

  {
    id: "requests",
    icon: "iconsminds-calendar-4",
    label: "Requests",
    role: [
      "superAdmin",
      "admin",
      "customerService"
    ],

    to: "/app/orders/requests"
  },
  {
    id: "appointments",
    icon: "iconsminds-calendar-4",
    label: "Appointments",
    role: [
      "superAdmin",
      "admin",
      "customerService"
    ],

    to: "/app/orders/appointments"
  },
  {
    id: "ratedOrders",
    icon: "simple-icon-star",
    label: "Rated Orders",
    role: [
      "superAdmin",
      "customerService",
      "admin"
    ],
    to: "/app/orders/rated"
  },

  // {
  //   id: "requests",
  //   icon: "iconsminds-calendar-4",
  //   label: "menu.requests",
  //   to: "/app/requests",
  //   role: [
  //     "superAdmin",
  //     "admin",
  //     "customerService"
  //   ]
  // },
  // {
  //   id: "appointments",
  //   icon: "iconsminds-calendar-4",
  //   label: "menu.appointments",
  //   to: "/app/appointments",
  //   role: [
  //     "superAdmin",
  //     "admin",
  //     "customerService"
  //   ]
  // },
  {
    id: "subscriptions",
    icon: "simple-icon-clock",
    label: "Subscriptions",
    to: "/app/subscriptions",
    role: [
      "superAdmin",
      "admin",
      "customerService",
      "finance"
    ]
  },
  {
    id: "chat",
    icon: "simple-icon-speech",
    label: "Chat",
    role: [
      "superAdmin",
      "admin",
      "customerService"
    ],
    to: "/app/chat"
  },

  {
    id: "services",
    icon: "iconsminds-wrench",
    label: "menu.services",
    to: "/app/services",
    role: [
      "superAdmin",
      "customerService",
    ]
  },
  {
    id: "up selling",
    icon: "iconsminds-wrench",
    label: "menu.upSelling",
    to: "/app/up-selling",
    role: [
      "superAdmin",
      "admin",
      "customerService"
    ]
  },
  {
    id: "CRMmenu",
    icon: "iconsminds-monitor-analytics",
    label: "CRM",
    to: "/app/crm",
    role: [
      "superAdmin",
      "customerService",
      "marketing",
      "finance"
    ],
    subs: [
      {
        icon: "simple-icon-people",
        label: "Customers",
        to: "/app/crm/customers",
        role: [
          "superAdmin",
          // "admin",
          "customerService",
          // "marketing",
          "finance"

        ]

      },
      {
        icon: "simple-icon-clock",
        label: "Orders",
        to: "/app/crm/orders",
        role: [
          "superAdmin",
          "customerService",
          "marketing",
          "finance"

        ]

      },
      {
        icon: "simple-icon-heart",
        label: "Donations",
        to: "/app/crm/donations",
        // must match the donations read rule (superAdminPerm) in firestore.rules
        role: [
          "superAdmin",
          "customerService",
          "finance"
        ]
      },
      // {
      //   icon: "simple-icon-wallet",
      //   label: "Wallet Logs",
      //   to: "/app/crm/wallet-logs",
      //   role: [
      //     "superAdmin",
      //     "finance"
      //   ]

      // },

    ]
  },
  {
    id: "orderHistory",
    icon: "iconsminds-monitor-analytics",
    label: "Order History",
    to: "/app/crm/orders",
    role: [
      "admin",
    ],

  },
  {
    id: "marketing",
    icon: "iconsminds-loudspeaker",
    label: "Marketing",
    to: "/app/marketing",
    role: [
      "superAdmin",
      "customerService",
      "marketing"
    ],
    subs: [
      {
        icon: "iconsminds-qr-code",
        label: "Promocodes",
        to: "/app/marketing/promocodes",
        role: [
          "superAdmin",
          "customerService",
          "marketing"

        ]

      },
      {
        icon: "simple-icon-layers",
        label: "Banners",
        to: "/app/marketing/banners",
        role: [
          "superAdmin",
          "customerService",
          "marketing"

        ]
      },
      {
        icon: "simple-icon-star",
        label: "Featured Providers",
        to: "/app/marketing/featured",
        role: [
          "superAdmin",
          "customerService",
          // "marketing"

        ]

      },
      {
        icon: "simple-icon-people",
        label: "Referral Program",
        to: "/app/marketing/referral",
        role: [
          "superAdmin",
          
        ]
      },
      {
        icon: "simple-icon-trophy",
        label: "Loyalty Program",
        to: "/app/marketing/loyalty",
        role: [
          "superAdmin",
          'finance'
        ]
      },

      {
        icon: "iconsminds-gift-box",
        label: "Vouchers / Compensations",
        to: "/app/marketing/vouchers",
        role: [
          "superAdmin",
          "customerService",
          // "marketing"
        ]
      },
      {
        icon: "iconsminds-gift-box",
        label: "Marketing Vouchers",
        to: "/app/marketing/marketing-vouchers",
        role: [
          "superAdmin",
          "customerService",
          "marketing"
        ]
      },
      {
        icon: "iconsminds-filter-2",
        label: "Segments",
        to: "/app/marketing/segments",
        role: [
          "superAdmin",
          "marketing"
        ]
      },
      {
        icon: "iconsminds-megaphone",
        label: "Campaigns",
        to: "/app/marketing/campaigns",
        role: [
          "superAdmin",
          "marketing"
        ]
      },
      {
        icon: "iconsminds-repeat",
        label: "Automations",
        to: "/app/marketing/automations",
        role: [
          "superAdmin",
          "marketing"
        ]
      },
      // {
      //   icon: "iconsminds-gift-box",
      //   label: "Vouchers",
      //   to: "/app/marketing/vouchers",
      //   role: [
      //     "superAdmin",
      //     "customerService",
      //     // "marketing"
      //   ]

      // },
      // {
      //   icon: "iconsminds-gift-box",
      //   label: "Marketing Vouchers",
      //   to: "/app/marketing/marketing-vouchers", 
      //   role: [
      //     "superAdmin",
      //     "customerService",
      //     // "marketing"
      //   ]

      // }
    ]
  },
  {
    id: "vehicles",
    icon: "iconsminds-car",
    label: "Vehicles",
    to: "/app/vehicles",
    role: ["superAdmin"],
    subs: [
      {
        icon: "iconsminds-car",
        label: "Cars",
        to: "/app/vehicles/cars",
        role: ["superAdmin"],
      },
      {
        icon: "iconsminds-motorcycle",
        label: "Bikes",
        to: "/app/vehicles/bikes",
        role: ["superAdmin"],
      },
      {
        icon: "iconsminds-bus-2",
        label: "Caravans",
        to: "/app/vehicles/caravans",
        role: ["superAdmin"],
      },
      {
        icon: "iconsminds-yacht",
        label: "Boats",
        to: "/app/vehicles/boats",
        role: ["superAdmin"],
      },
    ]
  },
  {
    id: "settings",
    icon: "simple-icon-settings",
    label: "Settings",
    to: "/app/settings",
    role: [
      "superAdmin"
    ],
    subs: [
      {
        icon: "simple-icon-refresh",
        label: "Order recovery",
        to: "/app/settings/order-recovery",
        role: ["superAdmin"]
      },
      {
        icon: "simple-icon-trophy",
        label: "Loyalty program",
        to: "/app/settings/loyalty",
        role: ["superAdmin"]
      },
      {
        icon: "simple-icon-people",
        label: "Referral program",
        to: "/app/settings/referral",
        role: ["superAdmin"]
      },
      {
        icon: "simple-icon-heart",
        label: "Awqaf donations",
        to: "/app/settings/donations",
        role: ["superAdmin"]
      },
      {
        icon: "simple-icon-star",
        label: "Rated orders",
        to: "/app/settings/rated-orders",
        role: ["superAdmin"]
      }
    ]
  },
];
export default data;
